import React from "react";

const Header = () => {
  return (
    <>
      <div className='header-todo'>
        <h2>Laksh's TODO</h2>
        <div className='icons'> </div>
      </div>
      <div className='head'> My TODO List </div>
    </>
  );
};

export default Header;
